import { useTranslation } from "react-i18next";

// Suspense fallback shown while a lazy-loaded route's chunk downloads —
// deliberately lightweight (no backdrop/blur/modal chrome like
// LoadingModal, which is for explicit in-app async actions) so a route
// transition doesn't flash a heavy overlay for what's usually a very
// brief chunk fetch.
export function PageLoadingFallback() {
  const { t } = useTranslation("common");
  return (
    <div className="flex items-center justify-center min-h-[40vh] w-full">
      <div
        className="h-8 w-8 rounded-full border-2 border-[rgb(var(--border))] border-t-[rgb(var(--text-accent))] animate-spin"
        role="status"
        aria-label={t("loading")}
      />
    </div>
  );
}
